
import { useEffect } from "react";
import { useGame } from "../data/gameContext";
import { AreSameLocation } from "../game/map/mapGenerator";


export default function useChaserDetection() {
  const { gameState, updateGameState } = useGame();

  useEffect(() => {
    const chaser = gameState.Chasers.find(
      (chaser) =>
        AreSameLocation(chaser.Location, gameState.PlayerCharacter?.Location)
    );
    if (chaser) {
      updateGameState({ Phase: "gameOver", GameOver: { reason: "Caught", endedBy: chaser.Name } });
    }
  }, [gameState.Chasers]);
}
